export default {"src":"/_next/static/media/carYellow.bfee69dc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};